export const defaultCountry = "uk".toLowerCase();
